export const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const daysUppercase = days.map((day) => day.toUpperCase());

export const daysObject = {
    MONDAY: {},
    TUESDAY: {},
    WEDNESDAY: {},
    THURSDAY: {},
    FRIDAY: {},
    SATURDAY: {},
    SUNDAY: {},
};

export const numberOfMilisecondsInADay = 86400000;

export const numberOfDaysInAWeek = 7;
